/* BFCM 2026 Phase 2 — PDP sale modules.

   Every number comes from RBSale. This file reads the engine and paints;
   it never computes a threshold, a gap or a subtotal itself (BFCM rule 1). */
(function () {
  'use strict';

  /* RUN-ONCE. rb-bf-pdp-assets is rendered by every module block, so several
     copies of this tag can be on one page. */
  if (window.__rbBfPdpBound) return;
  window.__rbBfPdpBound = true;

  var S = window.RBSale || null;

  /* ---- placeholder substitution ------------------------------------------
     {gap} {t1Value} {t2Value} {totalValue}, resolved from the engine. Money
     drops a decimal group that is actually 00, the same rule Phase 1's copy
     uses — "Add $33 more" reads, "Add $33.00 more" does not — while a real
     $33.50 gap keeps its cents. */
  function trimMoney(cents) {
    if (!S || !S.money) return '';
    var str = S.money(cents);
    return typeof str === 'string' ? str.replace(/([.,])00(?!\d)/, '') : str;
  }

  function fill(template, map) {
    return String(template || '').replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : '';
    });
  }

  /* ---- 3.1 final-hours band -----------------------------------------------
     Hours include whole days, so a band that shows early never reads 00.
     Ticks on rb:sale:tick only. */
  (function finalHours() {
    var root = document.querySelector('[data-bf-final]');
    if (!root || !S || !S.countdown) return;
    var h = root.querySelector('[data-bf-final-h]');
    var m = root.querySelector('[data-bf-final-m]');
    var sc = root.querySelector('[data-bf-final-s]');
    var clockBox = root.querySelector('.rb-bf-final__clock');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function paint() {
      var c = S.countdown('saleEnd');
      /* At zero the clock hides; the band stays until Last chance is off. */
      if (clockBox) clockBox.style.display = c.done ? 'none' : '';
      h.textContent = pad(c.d * 24 + c.h);
      m.textContent = pad(c.m);
      sc.textContent = pad(c.s);
    }
    paint();
    document.addEventListener('rb:sale:tick', paint);
  })();

  /* ---- 3.2 sale price and countdown ----------------------------------------
     Prices are the variant's own; the chip is (compare - price) / compare,
     rounded — the one sum BFCM rule 3 allows. The clock ticks on
     rb:sale:tick; nothing here runs its own interval (rule 10). */
  (function salePrice() {
    var root = document.querySelector('[data-bf-price]');
    if (!root || !S) return;
    var row = root.querySelector('[data-bf-price-row]');
    var clock = root.querySelector('[data-bf-price-clock]');
    var map = { selected: 0, variants: {} };
    try { map = JSON.parse(root.querySelector('[data-bf-price-variants]').textContent); }
    catch (e) { if (window.console) console.warn('[rb-bf-pdp] price map did not parse', e); }

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function paintPrice() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = (input && Number(input.value)) || Number(map.selected);
      var pair = map.variants[String(id)];
      if (!pair) return;
      var price = Number(pair[0]), compare = Number(pair[1]);
      if (!(compare > price)) { row.hidden = true; return; }
      /* The row is server-rendered by rb-price-label ('row' layout) for the
         variant the page loaded with; another variant only needs its three
         slots rewritten. If the page loaded on a variant without a compare-at
         the slots do not exist, so the row stays hidden rather than half
         built. Sizes here are sibling products; this path is for the rare
         product with real variants. */
      var was = row.querySelector('[data-rb-pr-was]');
      var now = row.querySelector('[data-rb-pr-now]');
      var chip = row.querySelector('[data-rb-pr-chip]');
      if (!was || !now || !chip) { row.hidden = true; return; }
      row.hidden = false;
      was.textContent = trimMoney(compare);
      now.textContent = trimMoney(price);
      chip.textContent = '−' + Math.round(((compare - price) / compare) * 100) + '%';
    }

    function paintClock() {
      if (!S.countdown) return;
      var c = S.countdown('saleEnd');
      /* The bar IS the countdown: at zero it hides (inline style beats the
         mode rules that display it). */
      var bar = clock.closest('.rb-bfp-price__bar');
      if (bar) bar.style.display = c.done ? 'none' : '';
      clock.textContent = pad(c.d) + 'd ' + pad(c.h) + 'h ' + pad(c.m) + 'm ' + pad(c.s) + 's';
    }

    paintPrice();
    paintClock();
    document.addEventListener('rb:sale:tick', paintClock);
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) form.addEventListener('change', paintPrice);
  })();

  /* ---- 3.5 gift scarcity meter ----------------------------------------------
     Reads RBSale.data.stock and nothing else. A null pct hides that bar; both
     null hide the module. The status text is the engine's. */
  (function scarcity() {
    var root = document.querySelector('[data-bf-scarcity]');
    if (!root || !S) return;
    function paint() {
      var stock = (S.data && S.data.stock) || {};
      var any = false;
      ['t1', 't2'].forEach(function (k) {
        var bar = root.querySelector('[data-bf-scar="' + k + '"]');
        var st = stock[k] || {};
        var pct = (st.pct === null || st.pct === undefined || st.pct === '') ? null : Number(st.pct);
        if (pct === null || isNaN(pct)) { bar.hidden = true; return; }
        any = true;
        bar.hidden = false;
        pct = Math.max(0, Math.min(100, pct));
        bar.querySelector('[data-bf-scar-fill]').style.width = pct + '%';
        bar.querySelector('[data-bf-scar-meter]').setAttribute('aria-valuenow', String(pct));
        bar.querySelector('[data-bf-scar-status]').textContent = st.status || '';
      });
      root.hidden = !any;
      var total = (S.data && S.data.tiers && S.data.tiers.totalValue) || 0;
      root.querySelector('[data-bf-scar-sub]').textContent = fill(root.getAttribute('data-bf-sub'), { totalValue: trimMoney(total) });
    }
    paint();
    document.addEventListener('rb:sale:phase', paint);
  })();

  /* ---- 3.8 sticky bar progress ----------------------------------------------
     The tracker's numbers exactly: progress(extra), extra = the selected
     variant's price unless it is already in the bag, fill = pctToT2. */
  (function stickyProgress() {
    var gapEl = document.querySelector('[data-bf-sticky-gap]');
    var fillEl = document.querySelector('[data-bf-sticky-fill]');
    if ((!gapEl && !fillEl) || !S || !S.progress) return;
    var variants = { selected: 0, prices: {} };
    try { if (gapEl) variants = JSON.parse(gapEl.getAttribute('data-bf-variants')); }
    catch (e) { if (window.console) console.warn('[rb-bf-pdp] sticky variant map did not parse; the gap will ignore the selected variant.', e); }

    function extra() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = (input && Number(input.value)) || Number(variants.selected) || 0;
      if (!id) return 0;
      var items = (S.cart && S.cart.items) || [];
      for (var i = 0; i < items.length; i++) if (Number(items[i].variant_id) === id) return 0;
      return Number(variants.prices[String(id)]) || 0;
    }

    function paint() {
      var t = (S.data && S.data.tiers) || {};
      var t1 = Number(t.t1 && t.t1.threshold) || 0, t2 = Number(t.t2 && t.t2.threshold) || 0;
      var twoValid = t2 > t1 && t1 > 0;
      var p = S.progress(extra());
      var c = S.progress(0);
      var pct = twoValid ? p.pctToT2 : (t1 > 0 ? Math.max(0, Math.min(1, p.projected / t1)) : 0);
      if (fillEl) fillEl.style.width = (pct * 100).toFixed(2) + '%';
      if (!gapEl) return;
      var key = 'below';
      if (twoValid) {
        if (c.t2Reached) key = 't2';
        else if (p.t2Reached) key = 't2-add';
        else if (p.t1Reached) key = 't1';
      } else if (c.t1Reached) key = 't2';
      else if (p.t1Reached) key = 't2-add';
      gapEl.textContent = fill(gapEl.getAttribute('data-bf-msg-' + key), { gap: trimMoney(p.gap) });
    }
    paint();
    document.addEventListener('rb:sale:cart', paint);
    document.addEventListener('rb:sale:phase', paint);
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) form.addEventListener('change', paint);
  })();

  /* ---- 3.3 gift unlock tracker -------------------------------------------- */
  (function tracker() {
    var root = document.querySelector('[data-bf-tracker]');
    if (!root || !S || !S.progress) return;

    var msgEl = root.querySelector('[data-bf-tracker-msg]');
    var fillEl = root.querySelector('[data-bf-tracker-fill]');
    var m1 = root.querySelector('[data-bf-marker="1"]');
    var m2 = root.querySelector('[data-bf-marker="2"]');
    var l1 = root.querySelector('[data-bf-label="1"]');
    var l2 = root.querySelector('[data-bf-label="2"]');

    var variants = { selected: 0, prices: {} };
    try {
      var raw = root.querySelector('[data-bf-tracker-variants]');
      if (raw) variants = JSON.parse(raw.textContent);
    } catch (e) {
      /* DO NOT FAIL SILENTLY. The default keeps the bar painting, but a map
         that will not parse means `extra` is silently 0 and the gap is wrong
         by a whole product — which is invisible whenever the selected variant
         happens to be in the cart already. That is exactly how the unquoted
         JSON key shipped, so it gets a console warning now. */
      if (window.console) console.warn('[rb-bf-pdp] variant price map did not parse; gap will ignore the selected variant.', e);
    }

    /* THE SELECTED VARIANT IS READ FROM THE FORM, not from the Liquid value.
       Liquid's selected_or_first_available_variant is only correct at render
       time; [name="id"] is what the shopper would actually add. */
    function selectedId() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var fromForm = input && Number(input.value);
      return fromForm || Number(variants.selected) || 0;
    }

    /* `extra` is the selected variant's price ONLY when it is not already in
       the cart. Adding it twice is the double-count the brief calls out, and
       it is easy to hit: add the item, and without this the tracker would
       claim you are further from the gift than you are. */
    function extraFor(id) {
      if (!id) return 0;
      var price = Number(variants.prices[String(id)]) || 0;
      var items = (S.cart && S.cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (Number(items[i].variant_id) === id) return 0;
      }
      return price;
    }

    function tiers() {
      var t = (S.data && S.data.tiers) || {};
      return {
        t1: Number(t.t1 && t.t1.threshold) || 0,
        t2: Number(t.t2 && t.t2.threshold) || 0,
        v1: t.t1 ? t.t1.value : 0,
        v2: t.t2 ? t.t2.value : 0,
        total: t.totalValue || 0
      };
    }

    function paint() {
      /* No tiers for this currency (no block of its own, or no Tier One
         threshold): render nothing. body.rb-tiers-none already hides it. */
      if (S.data && S.data.tiers && S.data.tiers.active === false) { root.hidden = true; return; }
      var t = tiers();
      var extra = extraFor(selectedId());
      var p = S.progress(extra);
      /* THE CART ON ITS OWN. "Unlocked" is only true once the bag itself has
         reached a tier; a tier reached only by counting the variant on screen
         is a promise, so it gets the "Add this to unlock" copy instead. */
      var c = extra ? S.progress(0) : p;

      /* AN INVALID PAIR IS NOT A SECOND TIER. If tier two's threshold is not
         above tier one's, the bar has nothing coherent to plot it against —
         so marker one and its label go, the end marker stands for tier one,
         and the copy stays tier-one, which is what the brief asks for. This
         is live today: AU's context overlays tier-four below tier-three, the
         same defect rb-sale.js warns about. */
      var twoValid = t.t2 > t.t1 && t.t1 > 0;

      var map = {
        gap: trimMoney(p.gap),
        t1: trimMoney(t.t1),
        t2: trimMoney(t.t2),
        t1Value: trimMoney(t.v1),
        t2Value: trimMoney(t.v2),
        totalValue: trimMoney(t.total)
      };

      /* BELOW TIER ONE, ITEM NOT IN THE BAG (2 Oct 2026). {gap} is the gap
         AFTER counting the selected variant, so "Add {gap} more" alone read
         as if {gap} were all the shopper needed. With the item in the bag
         (extra is 0) the gap is from the bag alone and 'below' is right.
         Applies in both modes: every branch below overrides it once a tier
         is reached, by the bag or by adding this. */
      var key = (extra && root.hasAttribute('data-bf-msg-below-add')) ? 'below-add' : 'below';
      if (twoValid) {
        if (c.t2Reached) key = 't2';
        else if (p.t2Reached) key = 't2-add';
        else if (c.t1Reached) key = 't1';
        else if (p.t1Reached) key = 't1-add';
      } else {
        /* SINGLE TIER (1 Oct 2026): no tier two — show-tier-four is off for
           this currency (the engine then sends t2 as 0), or the pair is
           inverted. Its own messages, never the "for both" ones; falls back
           to the old keys only if the block predates these settings. */
        if (c.t1Reached) key = root.hasAttribute('data-bf-msg-single') ? 'single' : 't2';
        else if (p.t1Reached) key = root.hasAttribute('data-bf-msg-single-add') ? 'single-add' : 't2-add';
      }
      msgEl.textContent = fill(root.getAttribute('data-bf-msg-' + key), map);

      /* The bar runs to tier two when there is one, otherwise to tier one —
         a bar whose end is a threshold nobody can reach is not a progress
         bar. pctToT2 is the engine's, so the maths stays in one place. */
      var pct;
      if (twoValid) pct = p.pctToT2;
      else pct = t.t1 > 0 ? Math.max(0, Math.min(1, p.projected / t.t1)) : 0;
      fillEl.style.width = (pct * 100).toFixed(2) + '%';

      /* Markers follow the PROJECTED total, as drawn: they show what adding
         this item would reach. The copy above is what says whether it has. */
      /* The labels under the bar are settings (1 Oct 2026); the defaults are
         the wording that used to be written here. */
      var labelOne = fill(root.getAttribute('data-bf-label-t1') || '{t1} \u00b7 {t1Value} gift', map);
      if (twoValid) {
        var at = ((t.t1 / t.t2) * 100).toFixed(2) + '%';
        if (m1) {
          m1.style.left = at;
          m1.classList.toggle('is-reached', !!p.t1Reached);
        }
        if (l1) { l1.style.left = at; l1.textContent = labelOne; }
        if (m2) m2.classList.toggle('is-reached', !!p.t2Reached);
        if (l2) l2.textContent = fill(root.getAttribute('data-bf-label-t2') || '{t2} \u00b7 {totalValue}', map);
      } else {
        if (m1) { m1.remove(); m1 = null; }
        if (l1) { l1.remove(); l1 = null; }
        if (m2) m2.classList.toggle('is-reached', !!p.t1Reached);
        if (l2) l2.textContent = labelOne;
      }
    }

    paint();
    /* Cart changes and phase changes both move these numbers. A variant
       change fires `change` inside the product form for any product that uses
       real variants; on this theme the size pills are links to sibling
       products, so a size change is a navigation and paint() runs on load. */
    document.addEventListener('rb:sale:cart', paint);
    document.addEventListener('rb:sale:phase', paint);
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) form.addEventListener('change', paint);

    if (S.refresh) S.refresh().then(paint).catch(function () {});
  })();

  /* ---- 3.6 make it a set --------------------------------------------------
     One controller per set on the page (the section and the block form can
     both be placed). Tier line = RBSale.progress(extra): extra is the SALE
     price (data-price, the variant's price in this market) of each chosen
     row NOT already in the bag; the engine adds the bag's qualifying
     subtotal. No compare-at is ever read here. One RBSale.add(items) call. */
  [].forEach.call(document.querySelectorAll('[data-bf-set]'), function makeItASet(root) {
    if (!S || !S.progress || !S.add) return;
    var subEl = root.querySelector('[data-bf-set-sub]');
    var lineEl = root.querySelector('[data-bf-set-line]');
    var bagEl = root.querySelector('[data-bf-set-bag]');
    var totalEl = root.querySelector('[data-bf-set-total]');
    var btn = root.querySelector('[data-bf-set-add]');
    var errEl = root.querySelector('[data-bf-set-error]');
    var busy = false;

    function inCart(id) {
      var items = (S.cart && S.cart.items) || [];
      for (var i = 0; i < items.length; i++) if (Number(items[i].variant_id) === id) return true;
      return false;
    }
    function chosen() {
      return [].filter.call(root.querySelectorAll('[data-bf-set-item]'), function (row) {
        if (row.hasAttribute('data-bf-set-main')) return true;
        var tick = row.querySelector('[data-bf-set-tick]');
        return tick && tick.checked;
      });
    }

    function paint() {
      var rows = chosen(), total = 0, extra = 0;
      rows.forEach(function (row) {
        var price = Number(row.getAttribute('data-price')) || 0;
        total += price;
        if (!inCart(Number(row.getAttribute('data-variant-id')))) extra += price;
      });
      [].forEach.call(root.querySelectorAll('[data-bf-set-item]'), function (row) {
        var tick = row.querySelector('[data-bf-set-tick]');
        if (tick) row.classList.toggle('is-on', tick.checked);
      });
      subEl.textContent = String(root.getAttribute('data-bf-sub') || '').replace('{X}', (S.data && S.data.headlineDiscount) || '');

      var t = (S.data && S.data.tiers) || {};
      var t1 = Number(t.t1 && t.t1.threshold) || 0, t2 = Number(t.t2 && t.t2.threshold) || 0;
      var twoValid = t2 > t1 && t1 > 0;
      var p = S.progress(extra);
      var key = 'below';
      if (twoValid && p.t2Reached) key = 't2';
      else if (p.t1Reached) key = twoValid ? 't1' : 't2';
      lineEl.textContent = fill(root.getAttribute('data-bf-line-' + key), { gap: trimMoney(p.gap) });

      /* Say where the rest of the running total comes from. */
      var bag = p.subtotal || 0, bagTpl = root.getAttribute('data-bf-line-bag');
      bagEl.hidden = !(bag > 0 && bagTpl);
      if (!bagEl.hidden) bagEl.textContent = fill(bagTpl, { bag: trimMoney(bag) });

      totalEl.textContent = trimMoney(total);
      btn.textContent = fill(root.getAttribute('data-bf-cta'), { n: rows.length, total: trimMoney(total) });
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-bf-set-tick]')) paint();
    });
    btn.addEventListener('click', function () {
      if (busy) return;
      var items = chosen().map(function (row) {
        return { id: Number(row.getAttribute('data-variant-id')), quantity: 1 };
      });
      busy = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('loading');
      errEl.hidden = true;
      S.add(items)
        .then(function () {
          [].forEach.call(root.querySelectorAll('[data-bf-set-tick]'), function (c) { c.checked = false; });
          paint();
        })
        .catch(function (err) {
          errEl.textContent = 'Something went wrong adding your set. Please try again.';
          errEl.hidden = false;
          if (window.console) console.warn('[rb-bf-pdp] set add failed', err);
        })
        .then(function () {
          busy = false;
          btn.removeAttribute('aria-busy');
          btn.classList.remove('loading');
        });
    });
    paint();
    document.addEventListener('rb:sale:cart', paint);
    document.addEventListener('rb:sale:phase', paint);
  });
})();
